import { Button } from '@mui/material';
import React, { FC, ReactElement } from 'react';

interface ITextButtonProps {
  text: string;
  onClick: () => void;
}

const TextButton: FC<ITextButtonProps> = ({ text, onClick }): ReactElement => {
  return (
    <Button
      variant="text"
      onClick={() => onClick()}
      size="small"
      sx={{
        height: '24px',
        textDecoration: 'underline !important',
        padding: '0!important',
        color: '#000!important',
        fontSize: '0.9rem',
        '&:hover': {
          background: 'none !important'
        },
        '& span': {
          display: 'none !important'
        }
      }}>
      {text}
    </Button>
  );
};

export default TextButton;
